<script setup lang="ts">

    import { useAttrs } from "vue";

    const attrs: any = useAttrs();
</script>

<template>
    <slot v-bind="attrs" />
</template>
